import { createFileRoute } from '@tanstack/react-router';
import { DevelopersLayout } from '../screens/developers/DevelopersLayout';

/** Public: the developer pages, the quickstart, the guides and the API reference. */
export const Route = createFileRoute('/developers')({
  component: DevelopersLayout,
});
